export default __webpack_public_path__ + "static/media/Feautured_4.350213b5.png";